module.exports = __webpack_public_path__ + "img/toronto-maple-leafs.d3f9a240.png";